// extracted by mini-css-extract-plugin
module.exports = {"movieCard":"MovieCard_movieCard__38eW7","movieImage":"MovieCard_movieImage__r4BzJ"};